import {
  answerQuestionDetails,
  LogOutActionTypes,
  LOGOUT_FAIL,
  LOGOUT_LOADING,
  LOGOUT_SUCCESS,
} from "./ActionTypes";
import { LogOutResponse } from "./Model";

const initialStateGetPosts: answerQuestionDetails = {
  loading: false,
  logoutRes: {} as LogOutResponse,
  errRes: "",
};
export const logOutReducer = (
  state = initialStateGetPosts,
  action: LogOutActionTypes
): answerQuestionDetails => {
  switch (action.type) {
    case LOGOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        logoutRes: action.payload,
        errRes: "",
      };
    case LOGOUT_LOADING:
      return {
        ...state,
        loading: true,
        logoutRes: {} as LogOutResponse,
      };
    case LOGOUT_FAIL:
      return {
        ...state,
        logoutRes: {} as LogOutResponse,
        loading: false,
        errRes: action.errRes,
      };
    default:
      return state;
  }
};
